import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

/** Floating back-to-top control that appears after scrolling down. */
export default function BackToTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  if (!show) return null;
  return (
    <button
      data-testid="back-to-top"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="Back to top"
      className="fixed bottom-6 right-6 z-50 w-11 h-11 flex items-center justify-center border border-borderGold bg-surface/90 backdrop-blur text-gold hover:text-goldHi hover:border-borderGoldHi transition-colors shadow-lg"
    >
      <ArrowUp className="w-5 h-5" />
    </button>
  );
}
